<template>
  <v-app-bar class="header-tab" height="48px" flat>
    <v-tabs align-with-title color="#765F36" background-color="#FDE6BB">
      <v-tabs-slider color="rgba(255, 0, 0, 0)"></v-tabs-slider>
      <v-tab
        v-for="(course, index) in courses"
        :key="index"
        style="text-transform: none"
        @click="courseSeleceted(index)"
        :class="changeCourseColor(index)"
      >
        {{ course.title }}</v-tab
      >
    </v-tabs>
  </v-app-bar>
</template>

<script>
export default {
  data: () => ({
    courses: [
      { title: "すべて", selected: false },
      { title: "iPhone", selected: false },
      { title: "Game", selected: false },
      { title: "Web", selected: false },
      { title: "WebExpert", selected: false },
      { title: "VideoEditor", selected: false },
      { title: "UIUX", selected: false },
      { title: "AI", selected: false },
    ],
  }),
  methods: {
    courseSeleceted(index) {
      // 色を変える
      for (let i = 0; i < this.courses.length; i++) {
        this.courses[i].selected = false
      }
      this.courses[index].selected = true

      // データに格納
      this.$store.commit("selectCourse", index)

      // 今までのproductデータを破棄
      this.$store.commit("resetProducts")

      // firebaseから取ってくる
      if (index === 0) {
        this.$store.dispatch("fetchProducts")
      } else {
        this.$store.dispatch("fetchSpecificProducts", index - 1)
      }
      this.$store.dispatch("resetNumberOfCards")
    },
    changeCourseColor(index) {
      return {
        clicked: this.courses[index].selected,
      }
    },
  },
  created() {
    this.courses[this.$store.state.selectIndex].selected = true
  },
}
</script>

<style lang="scss">
.header-tab {
  .clicked {
    background-color: #ffd588;
  }
}

@media screen and (max-width: 640px) {
  .header-tab {
    .v-slide-group__prev {
      display: none !important;
    }
  }
}
</style>
